import { useContext, useState } from "react";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { LocaleContext } from "../../../../routing/LangRouter";
import { navigateToLoginPage } from "../../../../utils/utility";

//import general components
import MobileHeader from "../../../../components/common/mobile-header/mobile-header";
import { BaseButton } from "../../../../components/common/base-button/base-button";
import BaseTextField from "../../../common/base-text-field/base-text-field";

//import images and icons
import { Add, ArrowForward, FolderOpen } from "iconsax-react";

//import styles
import "./request-form.scss";

function RequestForm({ getRequestList, handleClick, typeId, selectedSubType }) {
    //general
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    //upload file
    const [selectedFile, setSelectedFile] = useState("");
    const handleFileChange = e => {
        if (e.target.files) {
            const file = e.target.files[0];
            setSelectedFile(file);
        }
    };

    //remove file
    const removeFile = () => {
        setSelectedFile("");
    };

    //request for submit problem
    const [requestValue, setRequestValue] = useState({
        title: "",
        text: "",
    });

    const handleChangeFormValue = event => {
        const name = event.target.name;
        const value = event.target.value;
        setRequestValue(values => ({ ...values, [name]: value }));
    };

    const request = async () => {
        let params = new FormData();
        params.append("type", selectedSubType.id);
        params.append("title", requestValue.title);
        params.append("text", requestValue.text);
        params.append("attach", selectedFile);
        try {
            const response = await axios.post(`${BASE_URL}/account/user/request/create/`, params, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (response.status === 200) {
                toast.success(response.data.message, { toastId: "custom-id-yes" });
            }
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        } finally {
            handleClick("isMain");
            getRequestList();
        }
    };

    return (
        <>
            <MobileHeader title={t("support")} justifyContent="center" handleClick={() => handleClick("isSubType", typeId, selectedSubType)} />
            <Grid className="request-form" container item xs={12} rowGap={2}>
                <Grid container item xs={12}>
                    <Grid className="request-form__title-box" container item xs={12} sm={10} justifyContent={{ xs: "center", sm: "flex-start" }}>
                        <span className="request-form__title">{selectedSubType.name}</span>
                    </Grid>
                    <Grid
                        className="request-form__undo"
                        container
                        item
                        xs={2}
                        columnGap={1}
                        justifyContent="flex-end"
                        alignItems="center"
                        display={{ xs: "none", sm: "flex" }}
                        onClick={() => handleClick("isSubType", typeId, selectedSubType)}
                    >
                        {t("back")} <ArrowForward color="var(--primary-color)" />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={6} mt={{ xs: 6, sm: 0 }}>
                    <BaseTextField label={t("requestTitle")} name="title" value={requestValue.title} setValue={handleChangeFormValue} radius="10px" />
                </Grid>
                <Grid item xs={12}>
                    <BaseTextField
                        label={t("requestDescription")}
                        name="text"
                        value={requestValue.text}
                        setValue={handleChangeFormValue}
                        radius="10px"
                        multiline={true}
                        rows={6}
                    />
                </Grid>
                <Grid container item xs={12} rowGap={2} justifyContent="space-between">
                    {!selectedFile ? (
                        <Grid container item xs={12} sm={5} md={3} xl={2} justifyContent="center" alignItems="center">
                            <input id="logo" hidden type="file" name="logo" accept="image/*" onChange={handleFileChange} />
                            <label htmlFor="logo" className="request-form__upload-file">
                                <FolderOpen size="28" color="var(--secondary-color)" variant="Bold" cursor="pointer" />
                                <span>{t("uploadImage")}</span>
                            </label>
                        </Grid>
                    ) : (
                        <Grid className="request-form__file" container item xs={12} sm={5} md={3} xl={2.5} columnGap={1} alignItems="center">
                            <Add color="var(--red-color)" onClick={removeFile} cursor="pointer" />
                            <FolderOpen size="28" color="var(--primary-color)" variant="Bold" cursor="pointer" />
                            {selectedFile && `${selectedFile.name}`}
                        </Grid>
                    )}
                    <Grid className="request-form__request-button" container item xs={12} sm={5} md={3} xl={2} alignItems="flex-end">
                        <BaseButton
                            text={t("submitRequest")}
                            color="primary"
                            size="large"
                            radius="radius-10"
                            handleClick={request}
                            disabled={!requestValue.title || !requestValue.text}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default RequestForm;
